"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.shouldShowCaptionInsteadOfBlob = exports.rowPreviewCaption = exports.resolveRowDisplayCaption = exports.firstLineCaption = exports.looksLikeS1EncodedBody = void 0;
var compressionService_1 = require("./compressionService");
var outlineMapPrefs_1 = require("./outlineMapPrefs");
var FIRST_LINE_MAX = 160;
/** Encoded / compressed body: `s1 > caption > payload`. */
function looksLikeS1EncodedBody(body) {
    return !!(0, compressionService_1.parseCompressedPreamble)(body == null ? '' : String(body));
}
exports.looksLikeS1EncodedBody = looksLikeS1EncodedBody;
function firstLineCaption(body, max) {
    if (max === void 0) { max = FIRST_LINE_MAX; }
    var line = String(body || '')
        .split(/\r?\n/)[0]
        .trim();
    if (!line)
        return '';
    if (line.length <= max)
        return line;
    return line.slice(0, Math.max(1, max - 1)) + '…';
}
exports.firstLineCaption = firstLineCaption;
/**
 * Caption for result-row display mode:
 * custom style caption → s1 preamble → first line (truncated).
 */
function resolveRowDisplayCaption(body, style) {
    var custom = (style === null || style === void 0 ? void 0 : style.caption) != null ? String(style.caption).trim() : '';
    if (custom)
        return custom;
    var parsed = (0, compressionService_1.parseCompressedPreamble)(body == null ? '' : String(body));
    if (parsed === null || parsed === void 0 ? void 0 : parsed.preamble)
        return parsed.preamble;
    return firstLineCaption(body);
}
exports.resolveRowDisplayCaption = resolveRowDisplayCaption;
/**
 * If this is an s1 blob and the user picked outline (or no mode), show caption
 * instead of dumping the encoded payload. Explicit text mode still shows raw.
 */
/** Recent / compact strip: custom caption, s1 preamble, or first line. */
function rowPreviewCaption(row) {
    if (!row)
        return '';
    var style = (0, outlineMapPrefs_1.parseDisplayStyleFromRow)(row);
    return resolveRowDisplayCaption(row.pnBody, style);
}
exports.rowPreviewCaption = rowPreviewCaption;
function shouldShowCaptionInsteadOfBlob(body, mode) {
    if (mode === 'text')
        return false;
    if (mode === 'caption')
        return true;
    return looksLikeS1EncodedBody(body);
}
exports.shouldShowCaptionInsteadOfBlob = shouldShowCaptionInsteadOfBlob;
